import { useState } from "react"

import { pluralize } from "web/services/inflector"
import { isNonEmptyArray } from "web/services/helpers"

import routes from "web/routes/constants"

import Header from "./Header"
import Asset from "./Asset"
import Deal from "./Deal"

export default function SaleAssetLocationCard({
  primarySubject,
  location,
  assets,
  assetIds = [],
  saleAssets,
  saleAssetIds = [],
  onSelectionChanged,
  onClose,
}) {
  const haveAssets = isNonEmptyArray(assets)
  const haveSales = isNonEmptyArray(saleAssets)

  const numberOfAssets = haveAssets ? assets.length : assetIds.length
  const numberOfSales = haveSales ? saleAssets.length : saleAssetIds.length

  const showToggle = numberOfAssets + numberOfSales > 1
  const selectionEnabledInHeader = numberOfSales === 1

  const [expandedIndex, setExpandedIndex] = useState(numberOfAssets)

  function goToObject(subjectType, id) {
    if (subjectType == "sale") {
      window.Turbo.visit(`/markets/global/sales/view/${id}`) // TODO: UPDATE
    } else if (subjectType == "asset") {
      window.Turbo.visit(routes.tlo(pluralize(subjectType), "all", null, id))
    }
  }

  return (
    <div
      className="mb-4 flex w-64 cursor-pointer flex-col rounded-md bg-white pb-2 shadow-altrio-1"
      style={{ maxHeight: "calc(60vh - 80px)" }}
    >
      <Header
        title={primarySubject.name}
        location={location}
        primarySubject={primarySubject}
        selectionEnabled={selectionEnabledInHeader}
        onSelectionChanged={onSelectionChanged}
        onClick={() => goToObject("sale", primarySubject.id)}
        onClose={onClose}
      />
      <div className="flex-grow overflow-y-auto">
        {(haveAssets ? assets : assetIds).map((el, i) => {
          return (
            <Asset
              key={i}
              asset={haveAssets ? el : undefined}
              assetId={!haveAssets ? el : undefined}
              location={location}
              showToggle={showToggle}
              isExpanded={expandedIndex === i}
              selectionEnabled={false}
              onToggle={() => setExpandedIndex(i)}
              onClick={() => goToObject("asset", haveAssets ? el.id : el)}
              onSelectionChanged={onSelectionChanged}
            />
          )
        })}
        {(haveSales ? saleAssets : saleAssetIds).map((el, i) => {
          const saleAssetIndex = numberOfAssets + i

          return (
            <Deal
              key={i}
              deal={haveSales ? el : undefined}
              dealId={!haveSales ? el : undefined}
              showToggle={showToggle}
              isExpanded={expandedIndex === saleAssetIndex}
              selectionEnabled={!selectionEnabledInHeader} // TODO: change for others
              onToggle={() => setExpandedIndex(saleAssetIndex)}
              onClick={() => goToObject("sale", haveSales ? el.id : el)}
              onSelectionChanged={onSelectionChanged}
            />
          )
        })}
      </div>
    </div>
  )
}
